import {
  PAGE,
  RESET_PAGE,
  RESET_ACTIVE,
  UPDATE_ACTIVE,
  UPDATE_PAGE,
  CHANGE_ACTIVE,
  CHANGE_PAGE,
  DROP_REJECTED,
  POST_UPLOAD_FILE,
  POST_UPLOAD_FILE_START,
  POST_UPLOAD_FILE_SUCCESS,
  POST_UPLOAD_FILE_ERROR,
  UPDATE_REPORT_URL,
  NEW_REVISION_NAME_CHANGE,
  ADD_FILES,
  NEW_REVISION_NAME_CLEAR,
  CLEAR_ADD_FILES,
  TOGGLE_NVBUG_CHECKBOX
} from './constants'


const resetActive = () => ({ type: RESET_ACTIVE })
const resetPage = () => ({ type: RESET_PAGE })
const updateActive = (active, projectId) => ({ type: UPDATE_ACTIVE, active, projectId })
const updatePage = (page) => ({ type: UPDATE_PAGE, page })
const changePage = (page) => ({ type: CHANGE_PAGE, page })
const changeActive = (active) => ({ type: CHANGE_ACTIVE, active })
const dropRejected = (files) => ({ type: DROP_REJECTED, files })

const updateReportUrl = (value) => ({ type: UPDATE_REPORT_URL, value })

const setActive = () => changeActive(true)
const setInactive = () => changeActive(false)
const setUploadPage = () => changePage(PAGE.FILE_SELECTION)
const setLoadingPage = () => changePage(PAGE.UPLOADING)

const postUploadFile = (createNvbug) => ({ type: POST_UPLOAD_FILE, createNvbug })
const postUploadFileStart = () => ({ type: POST_UPLOAD_FILE_START })
const postUploadFileSuccess = () => ({ type: POST_UPLOAD_FILE_SUCCESS })
const postUploadFileError = (error) => ({ type: POST_UPLOAD_FILE_ERROR, error })

const changeNewRevisionName = (newName) => ({type: NEW_REVISION_NAME_CHANGE, newName})
const clearNewRevisionName = () => ({type: NEW_REVISION_NAME_CLEAR })

const addUploadFiles = (files) => ({type: ADD_FILES, files})
const clearUploadFiles = () => ({type: CLEAR_ADD_FILES })

const toggleNvbugCheckbox = () => ({ type: TOGGLE_NVBUG_CHECKBOX })

export {
  resetActive,
  resetPage,
  updateActive,
  updatePage,
  changePage,
  changeActive,
  setActive,
  setInactive,
  setUploadPage,
  setLoadingPage,
  dropRejected,
  postUploadFile,
  postUploadFileStart,
  postUploadFileSuccess,
  postUploadFileError,
  updateReportUrl,
  changeNewRevisionName,
  addUploadFiles,
  clearUploadFiles,
  clearNewRevisionName,
  toggleNvbugCheckbox
}
